"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: {
      '& .CircularProgressbar': {
        width: '100%',
        verticalAlign: 'middle'
      },
      '& .CircularProgressbar-path': {
        strokeLinecap: 'round',
        transition: 'stroke-dashoffset 0.5s ease 0s'
      },
      '& .CircularProgressbar-trail': {
        strokeLinecap: 'round'
      },
      '& .CircularProgressbar-text': (0, _extends2.default)({
        marginTop: 5,
        dominantBaseline: 'middle',
        textAnchor: 'middle'
      }, theme.typography.defaultText),
      '& .CircularProgressbar-inverted .CircularProgressbar-trail': {
        stroke: 'transparent'
      }
    },
    small: {
      width: 32,
      height: 32
    },
    medium: {
      width: 60,
      height: 60,
      '& .CircularProgressbar-text': {
        fontWeight: 500
      }
    },
    large: {
      width: 80,
      height: 80,
      '& .CircularProgressbar-text': {
        fontWeight: 500
      }
    }
  };
};

exports.default = _default;